import React, { useContext, useEffect, useState } from 'react';
import { Layout, Spin } from 'antd';
import styles from './Page.style.js';
import PageHeader from './PageHeader';
import { layout } from '../../styles/theme';
import { ThemeContext } from '../contexts/Theme.context';
import Head from 'next/head';
import ScrollDown from '../../components/ScrollDown/ScrollDown';

const { Header, Content, Footer } = Layout;

export default function Page({
  children,
  footer,
  backButton,
  showLanguageSelector,
  onLongPress,
  showShareButton,
  kioskDeviceUuid,
}) {
  const { state: theme } = useContext(ThemeContext);
  const customCss = theme && theme.customCss ? theme.customCss : '';
  const themeStyle = styles(theme);

  const [title, setTitle] = useState('Check-in');

  useEffect(() => {
    setTitle(window.location.hostname?.includes('checkout') ? 'Check-out' : 'Check-in');
  }, []);

  return theme ? (
    <>
      {kioskDeviceUuid && (
        <div
          style={{
            position: 'absolute',
            top: 0,
            right: 0,
            paddingTop: '8px',
            paddingRight: '24px',
          }}
        >
          <span>{'Terminal: '}</span>
          <b>{`${kioskDeviceUuid}`}</b>
        </div>
      )}
      <Head>
        {theme.customLink ? <link href={theme.customLink} rel="stylesheet" /> : null}
        <title>
          {theme.name} | {title}
        </title>
        <link rel="icon" href={theme.logo} />
      </Head>
      <Layout className={'layout'}>
        <Header
          className={`header ${theme.isIframe && theme.canUseIframe ? 'on-iframe-header' : ''}`}
        >
          <PageHeader
            backButton={backButton}
            showLanguageSelector={!theme.isKiosk && showLanguageSelector}
            onLongPress={onLongPress}
            showShareButton={showShareButton}
          ></PageHeader>
        </Header>
        <Content
          className={'content'}
          style={{ marginBottom: footer ? layout.marginWithFooter : 0, position: 'relative' }}
        >
          {children}
          {!theme.isKiosk && footer ? <div className={'form-footer footer'}>{footer}</div> : null}
        </Content>
        <ScrollDown></ScrollDown>
        {theme.isKiosk && footer ? <Footer className={'footer'}>{footer}</Footer> : null}
      </Layout>
      <style jsx global>
        {themeStyle}
      </style>
      <style jsx global>
        {`
          body {
            ${customCss}
          }
          #__next {
            min-height: 100%;
            background: ${theme.bgColor};
          }
          .footer.ant-layout-footer {
            background: transparent;
          }
          @media (min-width: 1024px) {
            .layout.ant-layout {
              max-width: calc(${theme?.isKiosk ? '80vw' : '50vw'} + 40px);
              margin: 0 auto;
            }
          }
        `}
      </style>
    </>
  ) : (
    <div className={'empty-page'}>
      <Spin></Spin>
      <style jsx global>{`
        .empty-page {
          display: flex;
          justify-content: center;
          align-items: center;
          height: 100vh;
        }
        .ant-spin-dot-item {
          background-color: #ccc;
        }
      `}</style>
    </div>
  );
}
